import React from 'react';
import {
    Text,
    TouchableOpacity,
    StyleSheet,
    ImageBackground,
    Dimensions
} from 'react-native';
import PropTypes from 'prop-types';
import Colors from "../../../../constants/Colors";

//TODO(Celso): questionTagNoSign is still coming from enqueteStack, move to quizzStack.

const QuizAnswerComponent = (props) => {

    /*  NOTE(Celso):
        index: the index of each answer.
        answerIndex: the index of the question, useful if there's more than one question being rendered.
    */

    const { answer, onPress, index, answerIndex, selectedValue } = props;

    //Making this optional, if it's not defined it will render a red and white borders.
    let { selectedColor, unselectedColor } = props;

    selectedColor = selectedColor !== undefined ? selectedColor : Colors.quizSelectionBorder;
    unselectedColor = unselectedColor !== undefined ? unselectedColor : Colors.borderColor;

    const { width } = Dimensions.get('window');

    return(
        <TouchableOpacity
            style={[styles.container, {
                borderColor: selectedValue !== index ?  unselectedColor : selectedColor,
                borderWidth: selectedValue !== index ? 1 : 6
            }]}
            onPress={() => onPress(index, answerIndex)}
        >
            <ImageBackground
                source={require('./img/question.png')}
                style={{ width: width*0.16, height: 64, justifyContent: 'center', alignItems: 'center',
                	margin: selectedValue !== index ? 7 : 2,
                	marginRight: 12,
            	}}
                resizeMode={'contain'}
            >
                <Text style={{ fontWeight: 'bold', fontSize: 22, color: 'white' }}>
                    {index+1}
                </Text>
            </ImageBackground>

            <Text style={[styles.answerText]}>
                {answer}
            </Text>
        </TouchableOpacity>
    )
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: 80,
        minWidth: '80%',
        maxWidth: '80%',
        marginTop: 10,
        padding: 8,
        backgroundColor: 'white',
        borderColor: Colors.borderColor,
    },
    selectedAnswer: {
        backgroundColor: Colors.buttonColor,
        borderColor: Colors.buttonColor
    },
    answerText: {
        fontSize: 18,
        textAlign: 'center',
        maxWidth: '68%'
    },
    selectedText: {
        color: 'white'
    }

});

QuizAnswerComponent.propTypes = {
    answer: PropTypes.string.isRequired,
    onPress: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    selectedValue: PropTypes.number.isRequired,
    answerIndex: PropTypes.number,

    selectedColor: PropTypes.string,
    unselectedColor: PropTypes.string,
};

export default QuizAnswerComponent;
